import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CurrencyCollectionQuery, CurrencyCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(CurrencyCollectionQuery)
@Wrapper(CurrencyCollectionQueryHandlerBase)
export class CurrencyCollectionQueryHandler {
    public constructor(
        http: Http
    ) {
    }
}
